import TopBar from "@/widgets/layout/TopBar"
import TopBarLayout from "./TopBarLayout"

export default function WithTopBarLayout() {
  return (
    <div className="flex h-screen flex-row overflow-hidden">
      <TopBarLayout TopBarComponent={TopBar} />
    </div>
  )
}
